export const NOTE_CANVAS_ID = 'canvas-note-wrapper';
export const NOTE_CONTAINER_ID = 'canvas-note-container-wrapper';
